"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SoundSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9,3.99720634 L9,14 L8.32308983,14.0018032 L5.34746819,12 L4,12 C3.44771525,12 3,11.5522847 3,11 L3,7 C3,6.44771525 3.44771525,6 4,6 L5.34861218,6 L8.35280268,3.99720634 L9,3.99720634 Z M5.65138782,7 L4,7 L4,11 L5.65253181,11 L8,12.5792227 L8,5.43425855 L5.65138782,7 Z M12,9 C12,8.11236311 11.6144993,7.31476475 11.0017876,6.76549472 L11.0017876,6.0027182 C11.3339292,6.00090607 11.5496336,6.00090607 11.6489009,6.0027182 C12.4775385,6.73559444 13,7.80678351 13,9 C13,10.1933589 12.4774138,11.2646612 11.6486043,11.9975441 C11.5495348,11.9991814 11.3333333,12 11,12 L11,11.2297283 C11.6096246,10.6806161 12,9.88506699 12,9 Z M13,4.52778699 L13,4 L13.8989827,4 C15.1955328,5.27051704 16,7.04131183 16,9 C16,10.9586882 15.1955328,12.729483 13.8989827,14 L13,14 L13,13.472213 C14.2274987,12.3735719 15,10.7769996 15,9 C15,7.22300037 14.2274987,5.62642809 13,4.52778699 Z" })));
};
SoundSmall.displayName = 'SoundSmall';
exports.default = SoundSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SoundSmall.js.map